import { Form, Input } from "antd";
import { validateEmail, getConfigAppPartType, validateUrl } from "../../utils";
import { AppPartType } from "../../AppForm/types";
import { validatePhone } from "../../AppCreate/validate";
import { Styles } from "./style";
interface IProps {
  isDisable?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  nameItem: string;
  styleColor?: React.CSSProperties;
  className?: string;
}

const LinkCusTom = (props: IProps) => {
  const {
    item,
    isDisable,
    style,
    nameItem,
    preview,
    isTable,
    styleColor = {},
    className,
  } = props;
  const {
    isHiddenLabel,
    minChar,
    maxChar,

    isAllowEditColumn,
    labelText,
  } = getConfigAppPartType(item);

  const form = Form.useFormInstance();
  const value = form.getFieldValue(nameItem);
  const { link_type } = item.item_config_data;
  let href = value; // link_type = url
  if (link_type == "phone_number") href = "tel:" + value;
  else if (link_type === "email") href = "mailto:" + value;

  return (
    <Styles style={style} className={`${isDisable && "disable"}`}>
      <Form.Item
        label={isHiddenLabel ? <div></div> : labelText}
        name={nameItem}
        rules={[
          {
            required: item?.is_required_field,
            message: `必須項目です`,
          },
          {
            min: minChar,
            message: `整数で指定のフィルードです。ご確認ください。`,
          },
          {
            max: maxChar,
            message: `整数で指定のフィルードです。ご確認ください。`,
          },
          ...(link_type === "url" || !link_type
            ? [
                {
                  message:
                    "URL 形式が無効です。URLは「http://」また「https://」で開始する必要があります。",
                  validator: (_: any, value: string) => {
                    if (!value || validateUrl(value)) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject("fail");
                    }
                  },
                },
              ]
            : []),
          ...(link_type === "email"
            ? [
                {
                  message:
                    "メールアドレス形式は無効です。例：username@example.comの形でお願いいたします。",
                  validator: (_: any, value: string) => {
                    if (validateEmail(value) || !value) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject("fail");
                    }
                  },
                },
              ]
            : []),
          ...(link_type === "phone_number"
            ? [
                {
                  message: "このフィールドは数字のみを受け付けます",
                  validator: (_: any, value: string) => {
                    if (!item.is_required_field && value === undefined)
                      return Promise.resolve();
                    if (validatePhone(value) || !value) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject("fail");
                    }
                  },
                },
              ]
            : []),
        ]}
        validateTrigger="onBlur"
        className={className}
      >
        <Input
          disabled={!isAllowEditColumn || isDisable || preview}
          onPressEnter={(e) => e.preventDefault()}
        />
      </Form.Item>
      {isDisable && (
        <div
          className={`value_text_container ${isTable && "table"}`}
          style={styleColor}
        >
          {value && (
            <a
              href={href}
              target="_blank"
              rel="noreferrer"
              style={{
                color: styleColor?.color,
              }}
            >
              {value}
            </a>
          )}
        </div>
      )}
    </Styles>
  );
};
export default LinkCusTom;
